import React from 'react'

import iconTimer from '~/images/icon-timer.svg'

const LoadTimeComparison = ({ block, vars }) => (
  <section className={`block ${block._template} ${block.css_class_name}`}>
    <div className="container">
      <div className='row'>
        <div className='comparison-col col-lg-5 offset-lg-1 col-md-6'>
          <div className='content-wr left'>
            {block.left.pre_title && ( <div className='pre-title'>{block.left.pre_title}</div> )}
            <div className='load-time-wr'>
              <img src={block.left.icon || iconTimer} alt={block.left.icon_alt_text || 'CDN load time comparison - bunny.net'} title={block.left.icon_alt_text || 'CDN load time comparison - bunny.net'} />
              <div className='load-time'>{block.left.load_time_override || vars.load_time_no_cdn}</div>
              <div className='text'>
                <strong>{block.left.time_label || 'seconds'}</strong>
                <span>{block.left.description_label || 'Website Load Time'}</span>
              </div>
            </div>
            {block.left.text && ( <div className="text-formatted" dangerouslySetInnerHTML={{__html: block.left.text}}></div> )}
            {block.left.image && (
              <img className='card-img' src={block.left.image} alt={block.left.image_alt_text} title={block.left.image_alt_text} />
            )}
          </div>
        </div>
        <div className='col-lg-5 col-md-6'>
          <div className='content-wr right'>
            {block.right.pre_title && ( <div className='pre-title'>{block.right.pre_title}</div> )}
            <div className='load-time-wr'>
              <img src={block.right.icon || iconTimer} alt={block.right.icon_alt_text || 'CDN load time comparison - bunny.net'} title={block.right.icon_alt_text || 'CDN load time comparison - bunny.net'} />
              <div className='load-time'>{block.right.load_time_override || vars.load_time_cdn}</div>
              <div className='text'>
                <strong>{block.right.time_label || 'seconds'}</strong>
                <span>{block.right.description_label || 'Website Load Time'}</span>
              </div>
            </div>
            {block.right.text && ( <div className="text-formatted" dangerouslySetInnerHTML={{__html: block.right.text}}></div> )}
            {block.right.image && (
              <img className='card-img' src={block.right.image} alt={block.right.image_alt_text} title={block.right.image_alt_text} />
            )}
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default LoadTimeComparison
